import { getAssetUrl } from '@cronos-app/chakra';
import { ChainId } from '@cronos-app/sdk';
export const explorers = {
    [ChainId.ETHEREUM]: 'https://etherscan.io',
    [ChainId.SEPOLIA]: 'https://sepolia.etherscan.io',
    [ChainId.ZK_EVM]: 'https://explorer.zkevm.cronos.org',
    [ChainId.ZK_EVM_TEST]: 'https://explorer.zkevm.cronos.org/testnet',
    [ChainId.CRONOS_EVM_MAINNET]: 'https://explorer.cronos.org',
    [ChainId.CRONOS_EVM_TESTNET]: 'https://explorer.cronos.org/testnet',
};
export const rpcUrls = {
    [ChainId.ETHEREUM]: 'https://eth-rpc.zkevm.cronos.org',
    [ChainId.SEPOLIA]: 'https://ethereum-sepolia-rpc.publicnode.com',
    [ChainId.ZK_EVM]: 'https://mainnet.zkevm.cronos.org',
    [ChainId.ZK_EVM_TEST]: 'https://testnet.zkevm.cronos.org',
    [ChainId.CRONOS_EVM_MAINNET]: 'https://mainnet.cronoslabs.com/v1/ea0f1c40f912a166bf1224fedd07b442',
    [ChainId.CRONOS_EVM_TESTNET]: 'https://testnet.cronoslabs.com/v1/ea0f1c40f912a166bf1224fedd07b442',
};
const CHAIN_CONFIG = {
    [ChainId.ETHEREUM]: {
        chainId: ChainId.ETHEREUM,
        chainName: 'Ethereum',
        nativeCurrency: {
            name: 'ETH',
            symbol: 'eth',
            decimals: 18,
        },
        rpcUrls: [rpcUrls[ChainId.ETHEREUM]],
        blockExplorerUrls: [explorers[ChainId.ETHEREUM]],
        chainIcon: getAssetUrl('/images/chains/ethereum.svg'),
    },
    [ChainId.SEPOLIA]: {
        chainId: ChainId.SEPOLIA,
        chainName: 'Sepolia',
        nativeCurrency: {
            name: 'ETH',
            symbol: 'eth',
            decimals: 18,
        },
        rpcUrls: [rpcUrls[ChainId.SEPOLIA]],
        blockExplorerUrls: [explorers[ChainId.SEPOLIA]],
        chainIcon: getAssetUrl('/images/chains/ethereum.svg'),
    },
    [ChainId.ZK_EVM]: {
        chainId: ChainId.ZK_EVM,
        chainName: 'Cronos zkEVM',
        nativeCurrency: {
            name: 'zkCRO',
            symbol: 'zkcro',
            decimals: 18,
        },
        rpcUrls: [rpcUrls[ChainId.ZK_EVM]],
        blockExplorerUrls: [explorers[ChainId.ZK_EVM]],
        chainIcon: getAssetUrl('/images/chains/zkevm.svg'),
    },
    [ChainId.ZK_EVM_TEST]: {
        chainId: ChainId.ZK_EVM_TEST,
        chainName: 'Cronos zkEVM Testnet',
        nativeCurrency: {
            name: 'zkTCRO',
            symbol: 'zkTCRO',
            decimals: 18,
        },
        rpcUrls: [rpcUrls[ChainId.ZK_EVM_TEST]],
        blockExplorerUrls: [explorers[ChainId.ZK_EVM_TEST]],
        chainIcon: getAssetUrl('/images/chains/zkevm.svg'),
    },
    [ChainId.CRONOS_EVM_MAINNET]: {
        chainId: ChainId.CRONOS_EVM_MAINNET,
        chainName: 'Cronos EVM',
        nativeCurrency: {
            name: 'CRO',
            symbol: 'cro',
            decimals: 18,
        },
        rpcUrls: [rpcUrls[ChainId.CRONOS_EVM_MAINNET]],
        blockExplorerUrls: [explorers[ChainId.CRONOS_EVM_MAINNET]],
        chainIcon: getAssetUrl('/tokens/cro.svg'),
    },
    [ChainId.CRONOS_EVM_TESTNET]: {
        chainId: 338,
        chainName: 'Cronos EVM Testnet',
        nativeCurrency: {
            name: 'CRO',
            symbol: 'cro',
            decimals: 18,
        },
        rpcUrls: [rpcUrls[ChainId.CRONOS_EVM_TESTNET]],
        blockExplorerUrls: [explorers[ChainId.CRONOS_EVM_TESTNET]],
        chainIcon: getAssetUrl('/tokens/cro.svg'),
    },
};
export const getChainInfo = (chainId) => {
    return CHAIN_CONFIG[chainId];
};
export const getAddEthereumChainParameter = (chainId) => {
    const chainInfo = getChainInfo(chainId);
    return {
        chainId: chainInfo.chainId,
        chainName: chainInfo.chainName,
        nativeCurrency: chainInfo.nativeCurrency,
        rpcUrls: chainInfo.rpcUrls,
        blockExplorerUrls: chainInfo.blockExplorerUrls,
    };
};
